module.exports = __webpack_public_path__ + "static/media/reactLogo.8c043242.png";